import { render, staticRenderFns } from "./Dog-new.vue?vue&type=template&id=7ecdb42c&scoped=true&"
import script from "./Dog-new.vue?vue&type=script&lang=js&"
export * from "./Dog-new.vue?vue&type=script&lang=js&"
import style0 from "./Dog-new.vue?vue&type=style&index=0&id=7ecdb42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecdb42c",
  null
  
)

export default component.exports